import { Component, EventEmitter, OnDestroy, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { Store } from '@ngxs/store';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { BusinessSubject } from './../../../../_common/model/business-subject';
import { User } from './../../../../_common/model/user';
import { BaseSelectors } from './../../../../_common/state/base/base.selectors';

@Component({
    selector: 'lay-men-header',
    templateUrl: './lay-men-header.component.html',
    styleUrls: ['./lay-men-header.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class LayMenHeaderComponent implements OnInit, OnDestroy {
    @Output()
    // @TODO: Ignored with eslint-interactive on 2023-10-13
    // eslint-disable-next-line @angular-eslint/no-output-on-prefix
    onMenuSizeChange: EventEmitter<boolean> = new EventEmitter();

    public bs?: BusinessSubject = this.store.selectSnapshot(BaseSelectors.getBS);
    public user?: User = this.store.selectSnapshot(BaseSelectors.getUser);
    public isMin = false;
    private onDestroy$ = new Subject<void>();

    constructor(private store: Store) {}

    ngOnInit(): void {
        this.store
            .select(BaseSelectors.getBS)
            .pipe(takeUntil(this.onDestroy$))
            .subscribe(bs => (this.bs = bs));
    }
    ngOnDestroy(): void {
        this.onDestroy$.next();
    }

    public minMenu(): void {
        this.isMin = !this.isMin;
        this.onMenuSizeChange.emit(this.isMin);
    }
}
